import * as PIXI from "pixi.js";
import { Logger } from "../../../util/log/Logger";
import { GraphicsUtil } from "../../../util/view/GraphicsUtil";
import { LanguageManager } from "../../manager/LanguageManager";
import { AbstractView } from "../AbstractView";
import { ViewUtils } from "../../../util/view/ViewUtils";
/**
 * SGDSignposting.ts
 */
export class SGDSignposting extends AbstractView {
    constructor(gameName, landscapeProperties, portraitProperties) {
        super(landscapeProperties, portraitProperties);
        this.gameName = gameName;
        this.responsive = true;
        this.run();
    }
    createProperties(properties, portraitProperties) {
        super.createProperties(properties, portraitProperties);
        this.landscapeProperties = properties;
        this.portraitProperties = portraitProperties;
        this.uiProperties = this.getCurrentProperties();
    }
    create() {
        super.create();
        this.createBackground();
        this.createMessageTitle();
        this.createMessageBody();
    }
    postCreate() {
        super.postCreate();
        Logger.addObjectRef(this, "SGDSignposting");
    }
    destroy() {
        super.destroy();
        this.removeChildren();
        this.background.removeChildren();
        this.background.destroy();
        this.messageTitle.destroy();
        this.messageBody.destroy();
    }
    createBackground() {
        this.background = GraphicsUtil.createRectangle(new PIXI.Point(10, 10), 0xFFFFFF, 1);
        this.addChild(this.background);
    }
    getGameSize() {
        const gameSize = this.renderer.getGameSize(); //size of the game view
        let width = gameSize.x;
        let height = gameSize.y;
        if (this.parent) {
            const transformedSize = this.parent.toGlobal(gameSize, null, false); //size after parent transform is applied
            //undo parent transform so blocker fills screen
            width *= (gameSize.x / transformedSize.x);
            height *= (gameSize.y / transformedSize.y);
        }
        return new PIXI.Point(width, height);
    }
    createMessageTitle() {
        this.messageTitle = ViewUtils.createField(this, this.landscapeProperties.messageTitleProperties, this.portraitProperties?.messageTitleProperties);
        let locale = LanguageManager.getInstance().getLocale();
        this.messageTitle.setText(this.gameName);
    }
    createMessageBody() {
        this.messageBody = ViewUtils.createField(this, this.landscapeProperties.messageBodyProperties, this.portraitProperties?.messageBodyProperties);
    }
    handleResize(event) {
        super.handleResize(event);
        const gameSize = this.getGameSize();
        this.background.width = gameSize.x;
        this.background.height = gameSize.y;
    }
}
//# sourceMappingURL=SGDSignposting.js.map